import Vuex from "vuex";
import axios from "axios";
import store from "./store";

const agendaAtivaStore = new Vuex.Store({
  state: {
    loadingTecnicos: false,
    tecnicos: [],
    tipo_compromisso: null,
    loadingEditAgendamento: false
  },

  mutations: {
    SET_TECNICOS(state, tecnicos) {
      state.tecnicos = tecnicos;
    },
    SET_LOADING_TECNICOS(state, loadingTecnicos) {
      state.loadingTecnicos = loadingTecnicos;
    },
    SET_TIPO_COMPROMISSO(state, tipo_compromisso) {
      state.tipo_compromisso = tipo_compromisso;
    },
    SET_LOADING_EDIT_AGENDAMENTO(state, loadingEditAgendamento) {
      state.loadingEditAgendamento = loadingEditAgendamento;
    },
  },

  actions: {
    async getTecnicos({ commit }) {
      commit("SET_LOADING_TECNICOS", true);

      try {
        const response = await axios.get('api/dashboard/tecnicos/unidade');

        const data = response.data.data;
        const user = store.state.user;
        
        const tecnicos = data.filter(tecnico => tecnico.id !== user.tecnico.id);

        commit("SET_TECNICOS", tecnicos);

        return response;
      } catch (error) {
        swal.fire({
          title: "Ops!",
          html: "Ocorreu um erro inesperado!<br>",
          icon: "error",
        });
      } finally {
        commit("SET_LOADING_TECNICOS", false);
      }
    },

    async getAgendamentoById({ commit }, { agendamento_id }) {
      try {
        return await axios.get(`api/dashboard/agenda/${agendamento_id}`);
      } catch (error) {
        return error;
      }
    },

    async putAgendamento({ commit }, { agendamento_id, agendamento }) {
      try {
        const response = await axios.put(`api/dashboard/agenda/${agendamento_id}`, agendamento);

        commit("SET_LOADING_EDIT_AGENDAMENTO", true);

        return response
      } catch (error) {
        commit("SET_LOADING_EDIT_AGENDAMENTO", false);
        return error;
      }
    },

    async deleteAgendamento({ commit }, { agendamento_id }) {
      try {
        return await axios.delete(`api/dashboard/agenda/${agendamento_id}/delete`);
      } catch (error) {
        return error;
      }
    },
  }
});

export default agendaAtivaStore;
